let commonmenu;
if (localStorage.getItem("partnerId") == "002-sa") {

  commonmenu = [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fa fa-tachometer",
    },

    {
      name: "QR List",
      url: "/qrlist",
      icon: "fa fa-qrcode",
    },
    {
      name: "Scan List",
      url: "/ScanList",
      icon: "fa fa-list-alt",
    },
    {
      name: "All Scan Records",
      url: "/AllScanRecords",
      icon: "fa fa-list-alt ",
    },
    {
      name: "UpdateLang",
      url: "/UpdateLang",
      icon: "fa fa-list-alt ",
    },
    {
      name: 'DnS Triage',
      // url: '/appInterFace',
      url: '/dnsMobileApp',
      icon: "fa fa-mobile mobile_icon",
    },
    {
      name: 'Chat Room',
      url: '/Notes',
      icon: "fa fa-comments-o",
    },
    {
      name: 'User Creation',
      url: '/UserCreation',
      icon: "fa fa-user",
    },
    // {
    //   name: 'MobileUser',
    //   url: '/mobileUser',
    //   icon: "fa fa-mobile mobile_icon",
    // },
    // {
    //   name: 'EmailAuthorized',
    //   url: '/emailAuthorized',
    //   icon: "fa fa-envelope",
    // },
    // {
    //   name: 'Dat Credentials',
    //   url: '/datCredentials',
    //   icon: "fa fa-credit-card-alt",
    // },
    // {
    //   name: 'Insurance Management',
    //   url: '/insuranceManagement',
    //   icon: "fa-solid fa fa-car",
    // },
  ];
}
else if (localStorage.getItem("client") == "SWISS") {
  commonmenu = [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
    },

    {
      name: "QR List",
      url: "/qrlist",
      icon: "fa fa-qrcode",
    },
    {
      name: "All Scan Records",
      url: "/AllScanRecords",
      icon: "fa fa-list-alt",
    },
    {
      name: "Statistics",
      url: "/Statistics",
      icon: "fa fa-bar-chart",
    },
    {
      name: 'DnS Triage',
      url: '/dnsMobileApp',
      icon: "fa fa-mobile mobile_icon",
    },
    {
      name: 'Chat Room',
      url: '/Notes',
      icon: "fa fa-comments-o",
    },
  ];
}
else {

  commonmenu = [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fa fa-tachometer",
    },

    {
      name: "QR List",
      url: "/qrlist",
      icon: "fa fa-qrcode",
    },
    {
      name: "All Scan Records",
      url: "/AllScanRecords",
      icon: "fa fa-list-alt",
    },
    {
      name: 'DnS Triage',
      url: '/dnsMobileApp',
      icon: "fa fa-mobile mobile_icon",
    },
    {
      name: 'Chat Room',
      url: '/Notes',
      icon: "fa fa-comments-o",
    },
  ];
}

let dnsMenu = [

];

if (localStorage.getItem("partnerId") == "002-sa" || localStorage.getItem("partnerId") == "demo"
  || localStorage.getItem("partnerId") == "11-210601") {
  dnsMenu = [
    ...dnsMenu,
    {
      title: true,
      name: "Beta Report",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "3D View (Beta)",
      url: "/vehicleDentInfo3DNew",
      icon: "icon-info",
    },
  ];
}

const swissMenu = [

];

const slovaniMenu = [

];

const romaniaMenu = [

];
const otherDnsApp = [
  {
    title: true,
    name: "Guides",
    wrapper: {
      element: "",
      attributes: {},
    },
  },
  {
    name: "S/W Guide",
    url: "/SoftwareGuide",
    icon: "fa fa-info-circle",
  },
  {
    name: "H/W Assembly",
    url: "/HardwareAssembly",
    icon: "fa fa-info-circle",
  },
  {
    name: "Help",
    url: "/UserManual",
    icon: "fa fa-info-circle",
  },
  {
    name: "Help-Marker",
    url: "/Marker",
    icon: "fa fa-info-circle",
  },
]

var menu = [];

const pdftype = localStorage.getItem("client");

if (pdftype == "SWISS") {
  menu = [...commonmenu, ...swissMenu, ...otherDnsApp];
} else if (pdftype == "ROM") {
  menu = [...commonmenu, ...romaniaMenu, ...otherDnsApp];
} else if (pdftype == "OTHER") {
  menu = [...commonmenu, ...slovaniMenu, ...otherDnsApp];
} else {
  menu = [...commonmenu, ...dnsMenu, ...otherDnsApp];
}
export default {
  items: menu,
  langNav: menu
};
